module.exports = __webpack_public_path__ + "static/media/Material-Design-Iconic-Font.d2a55d33.woff";